import { render } from "./HeaderSection.vue?vue&type=template&id=0fde4a3c&scoped=true"
import script from "./HeaderSection.vue?vue&type=script&lang=js"
export * from "./HeaderSection.vue?vue&type=script&lang=js"

import "./HeaderSection.vue?vue&type=style&index=0&id=0fde4a3c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fde4a3c"]])

export default __exports__